<script lang="ts" setup>
import { ref } from 'vue'
import { ComboboxButton, ComboboxInput } from '@headlessui/vue'

const props = defineProps<{
  modelValue?: string
  placeholder?: string
  required?: boolean
  disabled?: boolean
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

const input = ref<InstanceType<typeof ComboboxInput>>()

const onChange = (e: Event & { target: HTMLInputElement }) => {
  emit('update:modelValue', e.target.value)
}
</script>

<template>
  <ComboboxButton
    as="div"
    class="flex"
    @click.stop
  >
    <slot>
      <DTFieldInput
        v-slot="{ inputAttrs, inputClass }"
        :placeholder
        :required
        :disabled
        wrapper-class="grow"
      >
        <ComboboxInput
          ref="input"
          v-bind="inputAttrs"
          :class="inputClass"
          :value="props.modelValue"
          @change="onChange"
        />
      </DTFieldInput>
    </slot>
  </ComboboxButton>
</template>
